import { render, staticRenderFns } from "./common-product-gridicon.vue?vue&type=template&id=7a4f96f0&scoped=true"
import script from "./common-product-gridicon.vue?vue&type=script&lang=js"
export * from "./common-product-gridicon.vue?vue&type=script&lang=js"
import style0 from "./common-product-gridicon.vue?vue&type=style&index=0&id=7a4f96f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f96f0",
  null
  
)

export default component.exports